import { Link } from 'react-router-dom';

const IconCastle = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z"/>
    <path d="M18 11V4H6v7"/>
    <path d="M15 22v-4a3 3 0 0 0-3-3a3 3 0 0 0-3 3v4"/>
    <path d="M22 11V4"/>
    <path d="M2 11V4"/>
    <path d="M6 4V2"/>
    <path d="M18 4V2"/>
    <path d="M10 4V2"/>
    <path d="M14 4V2"/>
  </svg>
);

const IconHourglass = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 22h14"/>
    <path d="M5 2h14"/>
    <path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22"/>
    <path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"/>
  </svg>
);

export default function PendingApproval() {
  return (
    <div className="min-h-screen bg-gray-950 text-white flex flex-col">
      <header className="border-b border-gray-800">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-2">
          <img src="https://www.castle.vision/castle-icon.png" alt="Castle" className="w-8 h-8" />
          <span className="font-bold text-lg tracking-tight text-white">Castle</span>
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-lg w-full text-center space-y-8">
          <div className="flex justify-center">
            <div
              className="w-24 h-24 rounded-full flex items-center justify-center"
              style={{ background: 'rgba(111, 181, 224, 0.1)', border: '1px solid rgba(111, 181, 224, 0.3)', color: '#6fb5e0' }}
            >
              <IconHourglass />
            </div>
          </div>

          <div className="space-y-3">
            <h1 className="text-3xl font-bold text-white">Your castle is in review</h1>
            <p className="text-gray-400 text-lg leading-relaxed">
              We received your profile and our team is reviewing your account.
              You'll get an email once you're approved and ready to receive support from your community.
            </p>
          </div>

          <div
            className="rounded-xl p-6 text-left space-y-4"
            style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}
          >
            <p className="text-sm font-semibold text-gray-300 uppercase tracking-widest">What happens next</p>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="flex items-start gap-3">
                <span className="mt-0.5 w-5 h-5 rounded-full bg-blue-900 text-blue-400 flex items-center justify-center text-xs font-bold flex-shrink-0">1</span>
                <span>Our team reviews your profile, usually within 1–2 business days.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-0.5 w-5 h-5 rounded-full bg-blue-900 text-blue-400 flex items-center justify-center text-xs font-bold flex-shrink-0">2</span>
                <span>You'll receive a confirmation email with next steps to connect your payout account.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-0.5 w-5 h-5 rounded-full bg-blue-900 text-blue-400 flex items-center justify-center text-xs font-bold flex-shrink-0">3</span>
                <span>Once approved, your castle page goes live and you can start receiving support.</span>
              </li>
            </ul>
          </div>

          <div className="space-y-3 pt-2">
            <Link
              to="/creator-dashboard"
              className="inline-block w-full py-3 px-6 rounded-lg font-semibold text-white transition"
              style={{ background: '#6fb5e0' }}
              onMouseOver={e => e.currentTarget.style.background = '#4fa2d4'}
              onMouseOut={e => e.currentTarget.style.background = '#6fb5e0'}
            >
              Go to my dashboard
            </Link>
            <p className="text-xs text-gray-600">
              Questions? Reach out at{' '}
              <a href="mailto:castleinfo@creatorpay.gg" className="text-blue-400 hover:text-blue-300">
                castleinfo@creatorpay.gg
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
